import { render, staticRenderFns } from "./ShopTab.vue?vue&type=template&id=4f4a2dc4&"
import script from "./ShopTab.vue?vue&type=script&lang=js&"
export * from "./ShopTab.vue?vue&type=script&lang=js&"
import style0 from "./ShopTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports